// План отката (restore-plan бэка) → счётчики и строки для диалогов подтверждения.
// Суммы в плане - в копейках, как min_order_price в базе.

const FIELD = {
  name: 'имя',
  type: 'цвет',
  time: 'время',
  min_order_price: 'мин. сумма',
  filial_id: 'филиал',
  status: 'статус',
  geometry: 'контур',
}
const COLOR_TITLE = { green: 'Зелёная', yellow: 'Жёлтая', red: 'Красная' }
const rub = (kop) => (kop == null ? '—' : (Number(kop) / 100).toLocaleString('ru') + ' ₽')
const min = (v) => (v == null ? '—' : v + ' мин')

export function planCounts (plan) {
  return [
    { key: 'update', label: 'изменится', value: (plan.update || []).length },
    { key: 'recreate', label: 'восстановится', value: (plan.recreate || []).length },
    { key: 'delete', label: 'удалится', value: (plan.delete || []).length },
    { key: 'unchanged', label: 'без изменений', value: plan.unchanged || 0 },
  ]
}

export function isPlanEmpty (plan) {
  return !(plan.update || []).length && !(plan.recreate || []).length && !(plan.delete || []).length
}

export function updateLine (item) {
  return `«${item.name}»: ${item.fields.map((f) => FIELD[f] || f).join(', ')}`
}

export function recreateLine (item) {
  return `«${item.name}»` + (item.softDeleted ? '' : ' (новая запись с прежним номером)')
}

// tiers[color] = { timeMin: [сейчас, станет], minSum: [сейчас, станет] }; показываем только меняющиеся.
// Цвет, которого нет с одной из сторон (null), - это не смена тарифа, а зоны цвета появятся или уйдут:
// это и так видно в списках зон
export function tierLines (tiers) {
  const known = (pair) => pair[0] != null && pair[1] != null
  return Object.entries(tiers || {})
    .filter(([, t]) => known(t.timeMin) && known(t.minSum))
    .filter(([, t]) => t.timeMin[0] !== t.timeMin[1] || t.minSum[0] !== t.minSum[1])
    .map(([color, t]) => {
      const parts = []
      if (t.timeMin[0] !== t.timeMin[1]) parts.push(`${min(t.timeMin[0])} → ${min(t.timeMin[1])}`)
      if (t.minSum[0] !== t.minSum[1]) parts.push(`${rub(t.minSum[0])} → ${rub(t.minSum[1])}`)
      return `${COLOR_TITLE[color] || color}: ${parts.join(', ')}`
    })
}

export function warningText (w) {
  if (w.code === 'jupiter_zones') {
    return `В филиале зон из Юпитера: ${w.count}. Крон в 00:30 может перезаписать их снова.`
  }
  if (w.code === 'jupiter_recreate') {
    return `Вернутся зоны из Юпитера: ${w.count}. Если в Юпитере их нет, ночной импорт удалит их снова.`
  }
  if (w.code === 'name_taken') return `Имя «${w.name}» уже занято другой зоной, после отката имена совпадут.`
  return w.code
}

export function restoreSummaryText (counts) {
  const c = counts || {}
  return `Версия возвращена: изменено ${c.update || 0}, восстановлено ${c.recreate || 0}, удалено ${c.delete || 0}`
}
